export type LikeBoolean =
  | boolean
  | null
  | void
  | string
  | 'yes'
  | 'no'
  | LikeBooleanArray;
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface LikeBooleanArray extends Array<LikeBoolean> {}

export function toBoolean(value: LikeBoolean): boolean | null {
  if (value === false || value === 'no') {
    return false;
  }
  if (value === true || value === 'yes') {
    return true;
  }
  if (!value) {
    return null;
  }
  if (Array.isArray(value)) {
    const len = value.length;
    if (len === 0) {
      return null;
    }
    if (len === 1) {
      return toBoolean(value[0]);
    }
    let result: boolean | null = null;
    for (let i = 0; i < len; i++) {
      if (i === 0) {
        result = toBoolean(value[i]);
      } else if (result !== toBoolean(value[i])) {
        return null;
      }
    }
    return result;
  }

  return null;
}
